import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'github-runners',
});

export const newRouteRef = createSubRouteRef({
  id: 'github-runners-new',
  parent: rootRouteRef,
  path: '/new',
});

export const editRouteRef = createSubRouteRef({
  id: 'github-runners-edit',
  parent: rootRouteRef,
  path: '/edit/group/:groupId/runner/:id',
});

export const removeRouteRef = createSubRouteRef({
  id: 'github-runners-remove',
  parent: rootRouteRef,
  path: '/remove',
});
